import { render, staticRenderFns } from "./ActionButtonEmbedReadOnly.vue?vue&type=template&id=5858863b&"
import script from "./ActionButtonEmbedReadOnly.vue?vue&type=script&lang=js&"
export * from "./ActionButtonEmbedReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports